import { MdPrint, MdFileDownload } from 'react-icons/md';
import '../../../components/shared/PrintActionsHeader.css';

/** Themed Print / Export bar for Finance → Journal Ledger (matches sales pages). */
export default function JournalPrintBar({ onAction }) {
  const run = (action) => {
    if (typeof onAction === 'function') onAction(action);
    else window.dispatchEvent(new CustomEvent('finance-journal-export', { detail: { action } }));
  };

  return (
    <div
      className="print-actions-header admin-finance-journal-print-bar"
      role="toolbar"
      aria-label="Journal ledger print and export"
      data-journal-print-bar="1"
    >
      <div className="print-actions-buttons">
        <button type="button" className="owner-btn owner-btn-secondary owner-btn-sm" onClick={() => run('print')}>
          <MdPrint aria-hidden /> Print
        </button>
        <button type="button" className="owner-btn owner-btn-secondary owner-btn-sm" onClick={() => run('csv')}>
          <MdFileDownload aria-hidden /> CSV
        </button>
        <button type="button" className="owner-btn owner-btn-secondary owner-btn-sm" onClick={() => run('pdf')}>
          <MdFileDownload aria-hidden /> PDF
        </button>
        <button type="button" className="owner-btn owner-btn-secondary owner-btn-sm" onClick={() => run('excel')}>
          <MdFileDownload aria-hidden /> Excel
        </button>
        <button type="button" className="owner-btn owner-btn-primary owner-btn-sm" onClick={() => run('export')}>
          Export
        </button>
      </div>
    </div>
  );
}
